import { jsx as _jsx } from "react/jsx-runtime";
import { GasFeeView } from './GasFeeView';
import { DetailedEstimatesView } from './DetailedEstimatesView';
import { ExtendedAddress } from '../../../../../../components/Input/Address/AddressPicker/AddressWithIcon';
import { useSelectedAccount } from '../../../../../../context/swapAccounts';
import { isGaslessCapableRoute } from '../../../../../../helpers/gasless';
import { resolveTokenUsdPrice } from '../../../../../../helpers/tokenHelper';
import useWallet from '../../../../../../hooks/useWallet';
import { Address } from '../../../../../../lib/address/Address';
import useSWRGas from '../../../../../../lib/gases/useSWRGas';
import useSWRNftBalance from '../../../../../../lib/nft/useSWRNftBalance';
import { useGaslessPreferenceStore } from '../../../../../../stores/gaslessPreferenceStore';
import { useMemo } from 'react';
import { Slippage } from '../Slippage';
export const DetailedEstimates = ({ quote, reward, swapValues: values, variant, enabled = true, }) => {
    const shouldCheckNFT = reward?.campaign_type === 'for_nft_holders' &&
        reward?.nft_contract_address;
    const { balance: nftBalance, isLoading, error, } = useSWRNftBalance(values.destination_address || '', values.to, reward?.nft_contract_address || '', { enabled: enabled && !!shouldCheckNFT });
    const showReward = !(!reward ||
        !values.destination_address ||
        (shouldCheckNFT &&
            (isLoading || error || nftBalance === undefined || nftBalance <= 0)));
    return (_jsx(DetailedEstimatesView, { quote: quote, reward: reward, values: values, variant: variant, showReward: showReward, gasFee: _jsx(GasFee, { values: values, quote: quote, enabled: enabled }), slippage: _jsx(Slippage, { quoteData: quote, values: values }), tokenAddress: values.fromAsset?.contract &&
            values.from &&
            Address.isValid(values.fromAsset.contract, values.from) ? (_jsx(ExtendedAddress, { address: values.fromAsset.contract, network: values.from, showDetails: false, shouldShowChevron: false })) : undefined }));
};
export const GasFee = ({ values, quote, enabled = true, }) => {
    const isCEX = !!values.fromExchange;
    const sourceAccountNetwork = !isCEX ? values.from : undefined;
    const { provider } = useWallet(sourceAccountNetwork, 'withdrawal');
    const selectedSourceAccount = useSelectedAccount('from', sourceAccountNetwork?.name);
    const wallet = useMemo(() => provider?.connectedWallets?.find((w) => w.id === selectedSourceAccount?.id), [provider?.connectedWallets, selectedSourceAccount]);
    const { gasData, isGasLoading } = useSWRGas(selectedSourceAccount?.address, sourceAccountNetwork, values.fromAsset, values.amount, wallet, { enabled });
    const gasTokenPriceInUsd = resolveTokenUsdPrice(gasData?.token, quote);
    const gasFeeInUsd = gasData?.gas && gasTokenPriceInUsd
        ? gasData.gas * gasTokenPriceInUsd
        : null;
    const gas = gasData?.gas;
    const gasCurrencyName = gasData?.token?.asset;
    const gaslessEnabled = useGaslessPreferenceStore((s) => s.gaslessEnabled);
    const setGaslessEnabled = useGaslessPreferenceStore((s) => s.setGaslessEnabled);
    // Paymaster covers source-chain gas on the gasless route.
    const sourceIsSupported = !!wallet?.asSourceSupportedNetworks?.some((n) => n === values.from?.name);
    const isGaslessCapable = isGaslessCapableRoute({
        depositMethod: values.depositMethod,
        supportsGaslessDeposit: values.fromAsset?.supports_gasless_deposit,
        sourceTokenContract: values.fromAsset?.contract,
        gaslessStandard: values.fromAsset?.gasless_standard,
        sourceIsSupported,
        sourceAddress: selectedSourceAccount?.address,
    });
    return (_jsx(GasFeeView, { gasFeeInUsd: gasFeeInUsd, gas: gas, gasCurrencyName: gasCurrencyName, isGasLoading: isGasLoading, isGaslessCapable: isGaslessCapable, gaslessEnabled: gaslessEnabled, setGaslessEnabled: setGaslessEnabled }));
};
